var map = {
	"./br.svg": 1603,
	"./cs.svg": 1604,
	"./de.svg": 1605,
	"./en.svg": 1606,
	"./es.svg": 1607,
	"./fi.svg": 1608,
	"./fr.svg": 1609,
	"./hu.svg": 1610,
	"./it.svg": 1611,
	"./nl.svg": 1612,
	"./no.svg": 1613,
	"./pl.svg": 1614,
	"./ro.svg": 1615,
	"./ru.svg": 1616,
	"./sk.svg": 1617,
	"./sv.svg": 1618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1602;